import { Modal } from "@mantine/core";
import React from "react";

import ModalHeader from "components/ModalHeader";
import UpdateClientForm from "./UpdateClientForm";
import { Client } from "api/client/updateClient";
// import AddClientForm from "./AddClientForm";

type UpdateClientProps = {
  opened: boolean;
  onClose: () => void;
  // onUpdated: () => void;
  client: Client | null;
};

function UpdateClientModal({ opened, onClose, client }: UpdateClientProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Update Client"
        onClose={onClose}
        ariaLabel="Close Update client modal"
      />
      <UpdateClientForm client={client} onClose={onClose} />
    </Modal>
  );
}

export default UpdateClientModal;
